<template>
	<div id="searchBox"  v-loading.fullscreen.lock="fullscreenLoading">
    <baidu-map class="mapGoogle" id="map" :center="center" :zoom="zoom" @ready="init" :scroll-wheel-zoom='true'></baidu-map>
		<div class="searchBox">
			<div class="searchInput">
				<input v-model="searchInput" class="controls" type="text" placeholder="请输入地址">
				<ul>
					<li :class="{active:index === activeIndex}" v-for="(item,index) in searchList" :key="item.longitude" @click="setSearch(item);activeIndex=index">{{item.addr}}</li>
				</ul>
			</div>
			<el-button class="sureBtn" type='primary' @click='searchFun'>搜索</el-button>
		</div>
		<span v-if="showSearch" class="sure" @click="sureBox">选择当前地址</span>
		<img class="close" @click="closeFun" src="./img/close1.png" alt="">
	</div>

</template>


<script>
// import { MP } from './map.js'
	import constants from '@/util/constants.js';
	import coordtransform from './coordtransform.js';
	import { searchAddrCode,searchAddrByGps,searchLocByHit } from '@/views/axios/api.js';
	export default {
		data() {
			return {
        // ak:'z5IAghTlhij7Bz088j2glMxhmEtNme2v',
				lngtxt:'',
				lattxt:'',
				addresstxt:'',
				map:null,
				marker:null,
				infowindow:null,
				geocoder:null,
				markersArray:[],
				searchText:'',
				focus:false,
				searchBox:null,
				addrText:{},
				addrCode:{},
				gpsGetData:{},
				inputText:'',//搜索
				showSearch:true,
				shoIndex:'',
				searchInput:'',
				searchList:[],
				fullscreenLoading:false,
        activeIndex:0,
        center: {lng: 116.407394, lat:39.9042  },
        zoom: 3
			}
		},
		methods: {
			setSearch(obj){
				this.clearOverlays(this.infowindow)
				this.addresstxt=obj.addr;
				this.lattxt=obj.latitude;
				this.lngtxt=obj.longitude;
				this.setiInit()
			},
			searchFun(){
				if(this.searchInput == '') return this.$message.error('输入不能为空');
				this.fullscreenLoading=true
				searchLocByHit({hit:this.searchInput})
				.then(res => {
					console.log(res,'地图搜索');
					if(res.data.code == 0){
						this.searchList=res.data.obj;
						if(this.searchList.length == 0){
							this.$message.error('抱歉未搜索到该地址')
						}
					}
					this.fullscreenLoading=false
				})
				.catch(err =>{
					console.log(err);
				})
			},
      init({BMap,map}) { //初始化地图
          console.log(this.lngtxt,this.lattxt,'我在初始化')
          var _this=this;
          // console.log(map,'初始化')
          this.map = map;
          var latlng = new BMap.Point(this.lngtxt, this.lattxt)
          var myOptions = {
            zoom: 16,
            center: latlng,
            gestureHandling: 'greedy',
            // mapTypeId: map.MapTypeId.ROADMAP
          };
          // this.map = new BMap.Map(map, myOptions);
          this.geocoder = new BMap.Geocoder();//实例化地址解析
          this.map.addEventListener('click',  
            function(event) { 
              _this.placeMarker(event.point);
            }
          );		
          // var input = document.getElementById('pac-input');
          // this.map.controls[_this.map.ControlPosition.TOP_LEFT].push(input);
          this.map.addEventListener('dragend',  
            function() { 
              if(_this.map)
                {
                  var maxX = _this.map.getBounds().getNorthEast().lng;
                  var maxY = _this.map.getBounds().getNorthEast().lat;
                  var minX = _this.map.getBounds().getSouthWest().lng;
                  var minY = _this.map.getBounds().getSouthWest().lat;
                  if (maxY > 85.2 || minY < -85){
                    _this.map.panTo(new google.maps.LatLng(35.05859375, 0.580078125));
                    return;
                  }
                }
            }
          );	
          

				  // var latlng = new google.maps.LatLng(this.lngtxt, this.lattxt)
				  // var myOptions = {
          //   zoom: 16,
          //   center: latlng,
          //   gestureHandling: 'greedy',
          //   mapTypeId: google.maps.MapTypeId.ROADMAP
          // };
          // this.map = new google.maps.Map(document.getElementById('map'), myOptions);
          // this.geocoder = new google.maps.Geocoder();//实例化地址解析
          // //监听点击地图事件
          // google.maps.event.addListener(_this.map, 'click', function (event) {
          //   _this.placeMarker(event.latLng);
          // });
          // // Create the search box and link it to the UI element.
          // var input = document.getElementById('pac-input');
          // console.log(google);
          // // this.searchBox = new google.maps.places.SearchBox(input);
          // this.map.controls[google.maps.ControlPosition.TOP_LEFT].push(input);
          // // console.log(places)
        


        /*注释
				// Bias the SearchBox results towards current map's viewport.
				// this.map.addListener('bounds_changed', function() {
				//    _this.searchBox.setBounds(_this.map.getBounds());
				// });


				// Listen for the event fired when the user selects a prediction and retrieve
				// more details for that place.
				// this.searchBox.addListener('places_changed', function() {
				// 	_this.searchEnter()
        // });
        */
				// google.maps.event.addListener(this.map, 'dragend',
				// function() {
			  //       if(_this.map)
			  //       {
			  //         var maxX = _this.map.getBounds().getNorthEast().lng();
			  //         var maxY = _this.map.getBounds().getNorthEast().lat();
			  //         var minX = _this.map.getBounds().getSouthWest().lng();
			  //         var minY = _this.map.getBounds().getSouthWest().lat();
			  //         if (maxY > 85.2 || minY < -85){
			  //           _this.map.panTo(new google.maps.LatLng(35.05859375, 0.580078125));
			  //           return;
			  //         }
			  //       }
				// });
			},
			searchEnter(){
				var markers = [];
				var _this=this
				  // var places = this.searchBox.getPlaces();

					if(!places) return
				  if (places.length == 0) {
					return;
				  }

				  // Clear out the old markers.
				  markers.forEach(function(marker) {
          // marker.setMap(null);
          _this.map.removeOverlay(marker);
				  });
				  markers = [];

          // For each place, get the icon, name and location.
          var bounds = new BMap.Bounds(); 
				  // var bounds = new google.maps.LatLngBounds();
				  places.forEach(function(place) {
					if (!place.geometry) {
					  console.log("Returned place contains no geometry");
					  return;
					}
					var url=''
					var icon = {
					  url: place.icon,
					  size: new BMap.Size(71, 71),
					  origin: new BMap.Point(0, 0),
					  anchor: new BMap.Point(17, 34),
					  scaledSize: new BMap.Size(25, 25)
					};
					//console.log(place.geometry.location.lat());
					_this.mapClick(place.geometry.location.lng,place.geometry.location.lat,place.name);
          // Create a marker for each place.
          markers.push(new BMap.Marker(new BMap.Point(place.geometry.location.lng, place.geometry.location.lat)),{
					  map: _this.map,
					  icon: icon,
					  title: place.name,
					});
					// markers.push(new google.maps.Marker({
					//   map: _this.map,
					//   icon: icon,
					//   title: place.name,
					//   position: place.geometry.location
					// }));

					if (place.geometry.viewport) {
					  // Only geocodes have viewport.
					  bounds.union(place.geometry.viewport);
					} else {
					  bounds.extend(place.geometry.location);
					}
				  });
				  this.map.fitBounds(bounds);
			},
			 placeMarker(location) {
         console.log(location)
				 var _this=this;
				this.clearOverlays(this.infowindow);//清除地图中的标记
        var marker = new BMap.Marker(new BMap.Point(location.lng, location.lat),
        {
					map: _this.map
				});
				this.markersArray.push(marker);
				//根据经纬度获取地址
				if (this.geocoder) {
					this.geocoder.getLocation({ 'location': new BMap.Point(location.lng, location.lat) }, function (results, status) {  //location反解析
						if (status == this.map.GeocoderStatus.OK) { //google.maps.GeocoderStatus.OK
							if (results[0]) {
								_this.attachSecretMessage(marker, results[0].geometry.location, results[0].formatted_address);
							}
						} else {
							alert("Geocoder failed due to: " + status);
						}
					});
				}
			},
			//在地图上显示经纬度地址
			attachSecretMessage(marker, piont, address) {
        
				var message = "<b>坐标:</b>" + piont.lat + " , " + piont.lng + "<br />" + "<b>地址:</b>" + address;
				this.infowindow = new BMap.InfoWindow(
					{
						content: message,
						size: new BMap.Size(50, 50)
					});
        // this.infowindow.open(this.map, marker);
        this.map.openInfoWindow(this.infowindow,marker); 
				if (typeof (this.mapClick) == "function") this.mapClick(piont.lng, piont.lat, address);
			},
			    //删除所有标记阵列中消除对它们的引用
			clearOverlays(infowindow) {
				console.log(infowindow);
				
			    if (this.markersArray && this.markersArray.length > 0) {
			        for (var i = 0; i < this.markersArray.length; i++) {
                  // this.markersArray[i].setMap(null);
                  this.map.removeOverlay(this.markersArray[i]);
			        }
			       this.markersArray.length = 0;
			    }
			    if (infowindow) {
			        infowindow.close();
			    }
			},
			setiInit() {
				var _this=this;
				// 页面加载显示默认lng lat address---begin
				if (this.lattxt != '' && this.lngtxt != '' && this.addresstxt != '') {
          var latlng = new BMap.Point(this.lngtxt, this.lattxt);
          console.log(latlng,'点击下拉')
					var marker = new BMap.Marker(new BMap.Point(this.lngtxt, this.lattxt),{
						map: _this.map
					});
					this.markersArray.push(marker);
					this.attachSecretMessage(marker, latlng, this.addresstxt);
				}
				// ---end
			},
			mapClick(lng, lat, address) {
				this.addrText={lng, lat, address}
				this.searchInput=address
				this.tagClick(lng,lat)
			},
			parendZx(addr,id){
				console.log(addr);
        		this.shoIndex=id
				if(typeof addr == 'object'){
					this.showSearch=false;
					var zh=coordtransform.GpsCorrect.transform(addr.latitude,addr.longitude);
					this.lattxt =zh[0]
					this.lngtxt =zh[1]
					this.addresstxt=addr.addr
					this.map.setCenter(new BMap.Point(addr.longitude, addr.latitude))
					this.setiInit();
					if(!constants.setTxt(this.addresstxt,'zh')){
						this.searchText=this.addresstxt;
					}else{
						if(this.languageIndex == 0){
							this.searchText=constants.setTxt(this.addresstxt,'zh')
						}else{
							this.searchText=constants.setTxt(this.addresstxt,'en')
						}
					}
					this.searchInput=this.searchText;
					return
				}
				// if(addr == '') return this.map.setZoom(3);
				this.clearOverlays(this.infowindow)
				if(!constants.setTxt(addr,'zh')){
					this.searchText=addr;
				}else{
					if(this.languageIndex == 0){
						this.searchText=constants.setTxt(addr,'zh')
					}else{
						this.searchText=constants.setTxt(addr,'en')
					}
				}
				var data={
					token:JSON.parse(window.localStorage.getItem("data")).data,
					hit:this.searchText
				}
				searchAddrCode(data)
				.then(res => {
					if(res.data.obj == undefined) {
						this.$message.error('未搜索到指定地址，请手动搜索！');
						this.searchInput=''
					}else{
						this.gpsGetData=res.data.obj
						this.addresstxt=res.data.obj.addr;
						this.lattxt=res.data.obj.latitude;
						this.lngtxt=res.data.obj.longitude;
						this.map.setCenter(new BMap.Point(this.lngtxt, this.lattxt))
						this.setiInit()
					}
				})
				.catch(err => {
					console.log(err)
				})
			},
			sureBox(){
				if(this.addrText.address == undefined){
					this.addrText={lng:this.lattxt, lat:this.lngtxt, address:this.addresstxt}
				}
				this.$emit('getGpshid',this.addrText,this.gpsGetData,this.shoIndex);
				this.searchList=[];
				this.searchInput='';
			},
			tagClick(lng, lat){
				var data={
					token:JSON.parse(window.localStorage.getItem("data")).data,
					lng,
					lat
				}
				searchAddrByGps(data)
				.then(res => {
					this.gpsGetData=res.data.obj;
				})
				.catch(err => {
					console.log(err)
				})
			},
			closeFun(){
				this.clearOverlays(this.infowindow);//清除地图中的标记
				this.$emit('getGpshid1');
				this.searchList=[];
				this.searchInput='';
			}
    },
		mounted() {
			// var timer =setInterval(() => {
				// if(typeof google == 'object'){
					// clearInterval(timer)
					// this.init()
				// }
      // },300)
		},
		computed: {
			languageIndex() {
				return this.$store.state.language
			}
		}

	}
</script>
<style>
	body,
	html {
		height: 100%;
		width: 100%;
	}

	#app {
		height: 100%;
		width: 100%;
	}
	.gm-style-mtc ,.gm-svpc{display: none;}
	.gm-control-active,.gm-fullscreen-control{display: none;}
</style>
<style scoped="scoped">
	#searchBox {
		width: 100%;
		height: 100%;
	}

	#map {
		width: 100%;
		height: 100%;
	}
	.searchBox{
		font-family: Roboto;
		font-size: 15px;
		font-weight: 300;
		margin-left: 12px;
		padding: 0 11px 0 13px;
		text-overflow: ellipsis;
		width: 300px;
		margin-top: 5px;
		position: absolute;
		top: 0;
		left: 0;
		display: flex;
	}
	.searchBox ul{
		background-color: #fff;
		border-top: 1px solid #ccc;
		margin-top: 5px;
		max-height: 300px;
		overflow-y: auto;
	}
	.searchBox li{
		line-height: 30px;
		border-bottom: 1px solid #ccc;
		cursor: pointer;
		padding:0 5px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap

	}
	.searchBox li:hover{
		background-color: #00ABF9
	}
	.searchBox li.active{
		background-color: #00ABF9
	}
	.controls{
		width: 300px;
		height: 32px;
		border: none;
		outline: none;
		display: block;
		padding:0 10px;
	}
	.sureBtn{padding: 0 20px;background-color: #00ABF9;color: white;line-height: 30px;cursor: pointer;margin-left: 10px;height: 30px;}
	.sure{position: absolute;top: 5px;left: 480px;display: inline-block;padding: 0 20px;background-color: #00ABF9;color: white;line-height: 32px;cursor: pointer;}
	
	.close{position: absolute; top: 10px;left: 50%;width: 30px;cursor: pointer;}
</style>



// WEBPACK FOOTER //
// src/views/map/searchMap.vue